import { render, staticRenderFns } from "./SurveyResultsPopup.vue?vue&type=template&id=d18870fe&scoped=true&"
import script from "./SurveyResultsPopup.vue?vue&type=script&lang=js&"
export * from "./SurveyResultsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SurveyResultsPopup.vue?vue&type=style&index=0&id=d18870fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18870fe",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SurveyResultsPopup.vue
// module id = null
// module chunks = 